module.exports = __webpack_public_path__ + "img/盲盒开盒完成背景.c0d9e060.png";